import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Badge,
  Button,
  Card,
  CardFooter,
  CardImg,
  Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';
import { Column } from 'components/Layout';

import { resources } from './data/resources';
import styles from './styles.scss';

const PER_PAGE = 8;

const ResourceTab = ({ type }) => {
  const resourcesData = resources[type];
  const totalPage = Math.ceil(resourcesData.data.length / PER_PAGE);
  const [curPage, setCurPage] = useState(1);
  const [activeIndex, setActiveIndex] = useState(-1);
  const setPage = curPage1 => setCurPage(curPage1);

  const currentPage = resourcesData.data.slice((curPage - 1) * PER_PAGE, curPage * PER_PAGE);

  return (
    <Fragment>
      <Column className="small-12 mb-4">
        <h4 className="mb-md-0">{resourcesData.title}</h4>
        <p className="mb-0">{resourcesData.description}</p>
      </Column>

      {currentPage.map((resource, idx) => (
        <Column className={`small-6 medium-4 large-3 ${styles.cardWrapper} ${activeIndex === idx ? styles.active : ''}`} key={idx}>
          <Card className="guide-card">
            <a
              className={styles.img}
              href={resource.content}
              target="_blank"
              onMouseEnter={() => setActiveIndex(idx)}
              onMouseLeave={() => setActiveIndex(-1)}
            >
              <CardImg top width="100%" src={resource.thumbnail} alt="Guide Image" />
            </a>
            <CardFooter className={`pt-2 pb-4 ${styles.footer}`}>
              <Badge color="primary">{resource.badge_label}</Badge>
              <h5 className="mt-1 mb-0">
                <a
                  href={resource.content}
                  target="_blank"
                  onMouseEnter={() => setActiveIndex(idx)}
                  onMouseLeave={() => setActiveIndex(-1)}
                >
                  {resource.title}
                </a>
              </h5>
              <p className="mt-1 mb-0">{resource.summary}</p>
            </CardFooter>
          </Card>
        </Column>
      ))}

      <Column>
        <Pagination aria-label="Page navigation example" className={`mt-2 ${styles.pagination}`}>
          <PaginationItem disabled={!(curPage - 1)}>
            <PaginationLink
              previous
              href="#"
              tag={Button}
              onClick={() => setPage(curPage - 1)}
            />
          </PaginationItem>
          {[...Array(totalPage).keys()].map((i, idx) => (
            <PaginationItem key={idx} active={i === curPage - 1}>
              <PaginationLink href="#" tag={Button} onClick={() => setPage(i + 1)}>
                {i + 1}
              </PaginationLink>
            </PaginationItem>
            ))}
          <PaginationItem disabled={totalPage <= curPage}>
            <PaginationLink
              next
              href="#"
              tag={Button}
              onClick={() => setPage(curPage + 1)}
            />
          </PaginationItem>
        </Pagination>
      </Column>
    </Fragment>
  );
};

ResourceTab.propTypes = {
  type: PropTypes.string,
};

ResourceTab.defaultProps = {
  type: 'guide',
};

export default ResourceTab;



// WEBPACK FOOTER //
// ./src/containers/pages/MarketingResources/ResourceTab.js